import classNames from 'classnames'
import { FieldValues, UseFormRegister } from 'react-hook-form'

import { FieldLabel } from '@/Atomic/Atoms/FieldLabel'
import { Icon } from '@/Atomic/Atoms/Icon'
import {
  BasicTextarea,
  BasicTextareaProps,
} from '@/Atomic/Atoms/Inputs/BasicTextarea'

import '../FieldStates.scss'
import './TextareaField.scss'

interface TextareaProps extends BasicTextareaProps {
  name: string
  label?: string
  requirementState?: 'required' | 'optional'
  labelRight?: React.ReactNode
  defaultValue?: string
  register?: UseFormRegister<FieldValues>
  className?: string
  invalid?: boolean
  error?: string
}

export const Textarea: React.FC<TextareaProps> = ({
  name,
  label,
  requirementState,
  labelRight,
  defaultValue,
  register,
  className,
  invalid = false,
  error,
  disabled,
  ...props
}) => {
  const isReadonlyField = Boolean(disabled)
  const isInvalidField = !isReadonlyField && invalid
  const effectiveError = isReadonlyField ? undefined : error

  return (
    <div
      className={classNames(className, {
        'field-invalid': isInvalidField,
        'field--readonly': disabled,
      })}
    >
      <div className="field-label-row">
        <FieldLabel
          name={name}
          label={label}
          requirementState={requirementState}
        />
        {labelRight}
      </div>
      <BasicTextarea
        name={name}
        defaultValue={defaultValue}
        register={register}
        disabled={disabled}
        {...props}
      />
      {effectiveError && (
        <div className="field-error" role="alert">
          <Icon icon="info-circle" size="sm" />
          <span>{effectiveError}</span>
        </div>
      )}
    </div>
  )
}
